import { Fragment } from 'react';

import { PageSection } from '../PageSection/PageSection';
import { useSearchResultsPageContext } from '../SearchResults/contexts/SearchResultsPageContext';
import { ExpertAdviceContent } from './ExpertAdvice';

export const ExpertAdviceForSRP = () => {
  const { adjacentVendors, expertAdvice } = useSearchResultsPageContext();

  if (adjacentVendors.length === 0) {
    return (
      <PageSection>
        <ExpertAdviceContent articles={expertAdvice} />
      </PageSection>
    );
  }

  return <Fragment />;
};
